/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

document.addEventListener('DOMContentLoaded', () => {
	const linkEl = document.getElementById('redirectLink')

	if (linkEl) {
		linkEl.click()
	}
})
